import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/hcaf-next-site/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/hcaf-next-site/src/app/sponsorship/components/PastSponsorsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/hcaf-next-site/src/app/sponsorship/components/SponsorshipInquiryForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/hcaf-next-site/src/app/sponsorship/components/SponsorshipTiers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/hcaf-next-site/src/app/sponsorship/components/WhySponsorSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/hcaf-next-site/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/hcaf-next-site/src/components/ui/AppImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/hcaf-next-site/src/components/ui/AppLogo.tsx");
